export interface TreeNode {
  id: string
  label: string
  children?: TreeNode[]
  multiplicity?: '1' | '*' | '1..*' | '0..1'
}

export interface Mapping {
  id: string
  inputs: string[]
  outputs: string[]
  position: { x: number; y: number }
  mappingFunction?: string
  parameters?: { [key: string]: any }
}
